var View = Backbone.Epoxy.View.extend({

    renderTemplate: function (name) {
        var template = Handlebars.compile($('#' + name).html());
        return this.$el.html(template(this.templateData || this));
    },

    render: function() {
        if (this.cssName) this.$el.addClass(this.cssName + '-view');
        if (this.templateName) this.renderTemplate(this.templateName);
        if (this.renderContent) this.renderContent();
        if (this.applyBindings) this.applyBindings();
        this.rendered = true;
        return this;
    },

    disable: function () {
        this.enabled = false;
        this.$el.empty().off();
        this.stopListening();
        this.undelegateEvents();
        this.removeBindings();
        if (this.view && this.view.disable) this.view.disable();
        if (this.views && Array.isArray(this.views)) {
            this.views.forEach(function (view) {
                if (view && view.disable) view.disable();
            });
        }
        if (this.refreshInterval) clearInterval(this.refreshInterval);
        if (this.rendered) this.rendered = false;
        return this;
    },

    enable: function () {
        this.enabled = true;
        this.render();
        this.delegateEvents();
        return this;
    },

    focus: function () {
        this.$('input, textarea, select, .btn').first().focus();
        return this;
    },

});
